import React from 'react';
import PropTypes from 'prop-types';
import gettext from 'js-utils/gettext';
import { create as createDeviceFingerprint } from 'device_fingerprint';

import ValidationFormField from 'eventbrite_design_system/validationFormField/ValidationFormField';
import InputField from 'eventbrite_design_system/inputField/InputField';

import { shouldDisplayError } from 'js-utils/redux';
import PasswordField from './PasswordField';
import CaptchaField from './CaptchaField';

export const FirstAndLastNameFields = ({ autoFocus }) => (
    <div className="eds-g-group">
        <div className="eds-g-cell eds-g-cell-6-12 eds-l-pad-right-2">
            <ValidationFormField
                name="firstName"
                label={gettext('First Name')}
                shouldDisplayError={shouldDisplayError}
                v2={true}
            >
                <InputField
                    type="text"
                    name="firstName"
                    id="firstName"
                    autoFocus={autoFocus}
                    data-automation="signup-first-name-field"
                    label={gettext('First Name')}
                    role="textbox"
                />
            </ValidationFormField>
        </div>
        <div className="eds-g-cell eds-g-cell-6-12 eds-l-pad-left-2">
            <ValidationFormField
                name="lastName"
                label={gettext('Last Name')}
                shouldDisplayError={shouldDisplayError}
                v2={true}
            >
                <InputField
                    type="text"
                    name="lastName"
                    id="lastName"
                    data-automation="signup-last-name-field"
                    label={gettext('Last Name')}
                    role="textbox"
                />
            </ValidationFormField>
        </div>
    </div>
);

export default class SignUpFields extends React.PureComponent {
    static propTypes = {
        recaptcha2PublicKey: PropTypes.string,
        showCaptcha: PropTypes.bool,
        fp: PropTypes.bool,
        socialSSOSettings: PropTypes.shape({
            facebook: PropTypes.object,
        }),

        /* Needed due to an issue with redux form rendering validation errors on
        nested stateful components. Even though submitFailed is not used,
        submitFailed needs to be passed to the nested stateful component
        to ensure validation errors are rendered.
        Ticket: EB-60045 */
        submitFailed: PropTypes.bool,
    };

    componentDidMount() {
        const { fp } = this.props;

        if (fp) {
            createDeviceFingerprint({ data: { fpid: '' } });
        }
    }

    render() {
        const {
            recaptcha2PublicKey,
            showCaptcha,
            submitFailed,
            shouldIncludeEmailConfirmation,
        } = this.props;

        const autoFocusFirstName = !shouldIncludeEmailConfirmation;

        return (
            <div>
                <FirstAndLastNameFields autoFocus={autoFocusFirstName} />
                <PasswordField submitFailed={submitFailed} />
                <CaptchaField
                    showCaptcha={showCaptcha}
                    recaptcha2PublicKey={recaptcha2PublicKey}
                    submitFailed={submitFailed}
                />
            </div>
        );
    }
}
